import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import { solutions } from '../cherrySoftwareContent';
import { SOLUTION_ILLUSTRATIONS } from './cherrySoftwareIllustrations';
import SectionHeader from './SectionHeader';
import GlassCard from './GlassCard';
import IconBadge from './IconBadge';

const Solutions = () => {
  const theme = useTheme();

  return (
    <Box id="soluciones" py={{ xs: 8, md: 10 }}>
      <SectionHeader
        overline={solutions.overline}
        title={solutions.title}
        icon="devices"
        align="left"
        maxWidth="100%"
      />
      <Grid container spacing={3}>
        {solutions.items.map((item) => {
          const Illustration = SOLUTION_ILLUSTRATIONS[item.id];
          const accent = theme.palette[item.color || 'primary'].main;

          return (
            <Grid item xs={12} sm={6} key={item.id}>
              <GlassCard data-aos="fade-up" accentPalette={item.color || 'primary'}>
                <CardContent sx={{ p: 3 }}>
                  <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={1}>
                    <IconBadge
                      icon={item.icon}
                      color={item.color || 'primary'}
                      variant="gradient"
                      size={48}
                      rounded="14px"
                    />
                    {Illustration ? <Illustration color={accent} /> : null}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5 }}>
                    {item.title}
                  </Typography>
                  <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                    {item.text}
                  </Typography>
                </CardContent>
              </GlassCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Solutions;
